import { PALETTE, SIZES, MQ_TABLET} from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../../components/common/responsive-dimension-values';

const WINDOW_WIDTH = ResponsiveDimensionValues.windowWidth;
const blue = '#13223b';
const grey = '#808080';
export default MediaQueryStyleSheet.create({
  mainWrapper: {
    flex: 1,
  },
  scrollViewStyle: {
    flex: 0.9
  },
  root: {
    paddingVertical: 10,
    paddingHorizontal: 10
  },
  content: {
    paddingHorizontal: 0,
  },
  headline: {
    textAlign: 'center',
    marginBottom: 20,
  },
  footer: {
    textAlign: 'center',
  },
  column: {
    flex: 1,
    flexDirection: 'column',
  },
  row: {
    flex: 0,
    flexDirection: 'row'
  },
  rowItem: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 10,
  },
  switchLabel: {
    flex: 1,
  },
  switchToggle: {
    alignItems: 'flex-end',
  },
  labelText: {
    flex: 0.85,
  },
  profilePadd: {
    paddingVertical: 0
  },
  empty: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  CurrTextInput: {
    height: 30,
    borderColor: 'gray',
    borderWidth: 1,
    borderRadius: 4,
    marginBottom: 5,
    marginRight: 8,
    width: 80,
    alignItems: 'center',
    flexDirection: 'row',
  },
  TextInput: {
    height: 30,
    borderColor: 'gray',
    borderWidth: 1,
    borderRadius: 4,
    marginBottom: 5,
    width: 345
  },
  RowBottom: {
    marginBottom: 5,
    marginTop: 8
  },
  disableButton: {
    backgroundColor: blue,
    textAlign: 'center',
    //paddingTop: 5,
  },
  buttonPosition: {
    flex: 0.1,
  },
  currentSelection: {
    flex: 2,
    textAlign: 'center',
    // paddingVertical: 9,
  },
  fullBlock: {
    paddingVertical: 9,
  },
  trigger: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  selectedCurrency: {
    color: PALETTE.primaryText,
    paddingHorizontal: 8
  },
  option: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingRight: 20,
  },
  listItemStyle: {
    backgroundColor: blue,
    paddingVertical: 5,
    paddingHorizontal: 20,
    marginBottom: 10
  },
  HighlightListItemStyle: {
    backgroundColor: blue,
    paddingVertical: 5,
    paddingHorizontal: 20,
    marginBottom: 10,
    borderLeftWidth: 2,
    borderLeftColor: PALETTE.loginSecondary,
  },
  label: {
    color: PALETTE.secondaryText,
    marginBottom: 8,
    paddingHorizontal: 15,
    paddingVertical: 5
  },
  leftRow: {
    flex: 0.5,
  },
  rightRow: {
    flex: 0.5,
    alignItems: 'flex-end',
    paddingRight: 5,
  },
  textWhite: {
    color: PALETTE.secondaryActive
  },
  textGrey: {
    color: grey,
  },
  alignRightStyle: {flex: 1, alignItems: 'flex-end'},
  templateContainer: {
    alignSelf: 'center',
    width: '100%',
  flexDirection:'column',
  flex: 0.7,
  marginTop: '16px'
  },
  checkBoxView: { flexDirection: 'row', alignItems: 'center', paddingTop: 40, paddingBottom: 15, marginTop: 5, justifyContent: 'space-between' },
  templateHeader: { marginBottom: 15 },
  templateView: {flex: 1, padding: 25},
  templateName: {
    minHeight: 40,
    flex: 1,
    paddingTop: 15
  }
});

export const editButtonIconColor = PALETTE.primaryText;
